//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class";
        },
      },
      columns: [
        {
          field: "name",
          key: "a",
          title: "资产/负债",
          align: "left",
          width: "50%",
        },
        {
          field: "date",
          key: "b",
          title: "年初余额",
          width: "25%",
          align: "right",
        },
        {
          field: "hobby",
          key: "c",
          title: "期末余额",
          width: "25%",
          align: "right",
        },
      ],
      tableData: [
        {
          name: "货币资金",
          date: "134,459.69",
          hobby: "367,220.39",
        },
        {
          name: "短期借款",
          date: "2,000,000.00",
          hobby: "4,671,000.00",
        },
        {
          name: "交易性金融资产",
        },
        {
          name: "交易性金融负债",
        },
        {
          name: "应收票据",
        },
        {
          name: "应付票据",
        },
        {
          name: "应收款项",
          date: "2,000,000.00",
          hobby: "4,671,000.00",
        },
        {
          name: "应付款项",
          date: "2,000,000.00",
          hobby: "4,671,000.00",
        },
      ],
    };
  },
};
